import {httpRequest} from "./http-request";

export const crossDockService = {
  createCrossDock,
  getRegionsList,
  getCitiesList,
  getStoresList,
  getLegalEntities,
  getPreset,
  getActualList,
  getArchiveList,
  sendCalculate,
  refuse,
  getOrdersToShipperCompanyList
};

async function getOrdersToShipperCompanyList() {
  return await httpRequest.get('approve-order/get-list-cross-dock-orders-to-shipper-companies').then((response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data);
    }

    return Promise.reject(httpRequest.getDefaultMessageError());
  });
}

async function getActualList() {
  return await httpRequest.post('cross-dock/get-actual-list')
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }
      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function sendCalculate(id) {
  return await httpRequest.post('cross-dock/send-calculate',
    {
      'Id': id
    })
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }
      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function createCrossDock(data) {
  return await httpRequest.post('cross-dock/create', data)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }
      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getLegalEntities() {
  return await httpRequest.get(`cross-dock/get-legal-entities`)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getRegionsList(country) {
  return await httpRequest.post(`store/get-regions`, {
    country: country
  })
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getCitiesList(regionIds) {
  return await httpRequest.post(`store/get-cities`, {
    regionIds: regionIds
  })
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getStoresList(regionIds, cityIds) {
  return await httpRequest.post(`store/get-stores`, {
    regionIds: regionIds,
    cityIds: cityIds
  })
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getPreset(legalEntityId, text) {
  return await httpRequest.get(`cross-dock/get-preset`, {
    params: {
      legalEntityId,
      text
    }
  })
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function refuse(id, reason = null) {
  const data = { 'Id': id };
  if (reason) {
    data['Reason'] = reason;
  }
  return await httpRequest.post('cross-dock/refuse', data)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }
      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getArchiveList() {
  return await httpRequest.post('cross-dock/get-archive-list')
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }
      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}
